import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type React from 'react';
import { DisplayBigNumber } from './DisplayBigNumber';
import { PercentBox } from './PercentBox';

type InsightItemProps = {
  title: string;
  value: number;
  percentage?: number;
  icon?: React.ReactNode;
  dataTestId?: string;
};

export function InsightItem({ title, value, icon, percentage, dataTestId }: InsightItemProps) {
  return (
    <Stack spacing={2}>
      <Stack
        spacing={1}
        direction="row"
        sx={{
          alignItems: 'center',
        }}
      >
        {icon}
        <Typography
          variant="overline"
          sx={{
            color: 'text.secondary',
          }}
        >
          {title}
        </Typography>
      </Stack>

      <Typography variant="h2" data-test={dataTestId}>
        <DisplayBigNumber number={value} />
      </Typography>

      <PercentBox value={percentage} />
    </Stack>
  );
}
